import {bindActionCreators} from 'redux'
import {loadPopupContentByRpcCall} from '../../../util/PopupLoadingUtils'
import CreateProjectLightbox from './CreateProjectLightbox'
import CorporateScheduleCalculator from '../../../controls/dateControls/CorporateScheduleCalculator'
import {unsafe_bindActions, unsafe_selectWithState} from '../../../redux/utils'
import {setViewerSettings} from '../../common/actions'
import {isPossibleToAddCustomers} from '../../common/selectors'
import {arrayToSet} from '../../../atUtils'
import {PROJECT_CONSTANTS} from './constants'

export default class CreateProjectPopupController {

    constructor({
        createProjectSuccessCb,
        createProjectFailureCb,
        setTypesOfWorkCb,
    }) {
        this.callbacks = {
            createProjectSuccessCb,
            createProjectFailureCb,
            setTypesOfWorkCb,
        }

        this.actions = unsafe_bindActions((dispatch) => ({
            setViewerSettings: bindActionCreators(setViewerSettings, dispatch)
        }))
    }

    showPopup(customerId) {
        this._requestPopupData(customerId,
            (contentData) => {
                new CreateProjectLightbox(
                    contentData,
                    {
                        successHandler: this.callbacks.createProjectSuccessCb,
                        failureHandler: this.callbacks.createProjectFailureCb,
                        setTypesOfWorkCb: this.callbacks.setTypesOfWorkCb
                    },
                ).init().show()
            },
            null
        )
    }

    _requestPopupData(customerId, onSuccessCb, onErrorCb) {
        loadPopupContentByRpcCall("ProjectInfoService.getNewProjectPopupInfo", [],
            (data) => {
                const corporateSchedule = data['corporateSchedule']
                const scheduleCalculator = new CorporateScheduleCalculator().init(window.invertedDaysDateMap, corporateSchedule)
                this.actions.setViewerSettings(data.viewerSettings)

                const customers = data['customers'].list
                let selectedCustomerId
                if (!!customers.find(({id}) => id === customerId))
                    selectedCustomerId = customerId
                else
                    selectedCustomerId = PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX

                return onSuccessCb({
                    customersInfo: customers,
                    customerId: selectedCustomerId,
                    billingTypes: data['billingTypes'] ? data['billingTypes'].list : null,
                    enabledFeatures: arrayToSet(data['enabledFeatures']),
                    defaultBillingTypeId: data['defaultBillingType'],
                    weekStartDay: data['weekStartDay'] - 1,
                    scheduleCalculator: scheduleCalculator,
                    projectsWithTasksExist: data['projectsWithTasksExist'],
                    user: data['user'],
                    isPossibleToCreateCustomer: unsafe_selectWithState(isPossibleToAddCustomers)
                })
            },
            true,
            onErrorCb,
            true)
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/project/CreateProjectPopupController.js